<template>
  <div class="login container">
    <div v-if="!sellCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <form v-else @submit.prevent="submit">


      <div class="d-flex justify-content-between">
        <div class="col-xs-6 pl-3 pt-5">
          <cta link="sell" shape="circle" icon="left-arrow" text="" margin="no-margin" />
      </div>

      <div class="col-xs-6  pr-3 pt-5">
            <cta type="submit" shape="circle" text="" icon="right-arrow" :disabled="email == '' || errors.has('email')" margin="no-margin" :loading="submitted" />
        </div>
      </div>

      <div class="row">
        <h2 class="col-md-12 pt-2">Send digital card to email</h2>
      </div>

      <div class="row">
        <div class="field">
            <text-input type="email" v-model="email" placeholder="Enter email address" name="email" v-validate="'required|email'"  />
        </div>
       </div>


    </form>
   
  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
          submitted     : false,
          email         : ''
      };
  },
  created:function(){
      this.init();
  },
  computed: {

    orderPayload(){
      return this.$store.getters.getOrderPayload;
    },

  },
  watch:{

   
  },
  mounted: function(){

  },
  methods:{
    init(){
      if(typeof this.orderPayload.email !== 'undefined') {
        this.email = this.orderPayload.email;
      }
    },

    submit()
    {
        
        this.$validator.validateAll().then((result) => {
          if(result){

            this.$set(this.orderPayload, 'email', this.email);
            this.$store.commit("ORDER_PAYLOAD",this.orderPayload);

            this.$router.push({ name: 'payment'});
          }
        })
    },

  }
}
</script>

<style scoped>

  .select-holder {
    margin-top: 15px;
  }

</style>
